/**
 * API Configs
 */
const config = {
  appConfig: {
    api: `http://3.130.152.114:8000`, // to be removed
    apiuser: `${process.env.REACT_APP_API_CTMS}`,
    apietmf: `${process.env.REACT_APP_API_ETMF}/etmf`,
    apictms: `${process.env.REACT_APP_API_CTMS}/ctms`,
    apiisf: `${process.env.REACT_APP_API_ISF}/isf`,
    apiSysAdmin: `${process.env.REACT_APP_API_SYSADMIN}`
  }
};
export default config;
